import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Jsonsmkyu9xjl7fv as Json } from '../../../../../kotlinx-serialization-kotlinx-serialization-json/kotlinx/serialization/json/Json.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { _Char___init__impl__6a9atxrzocepzq3zgi as _Char___init__impl__6a9atx } from '../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { PolymorphicKindla9gurooefwb as PolymorphicKind } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialKinds.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  decodeSerializableElement$defaulthisepbk9rprr as decodeSerializableElement$default,
  decodeSequentially27kmi8jnnsnbc as decodeSequentially,
  decodeCollectionSize3l4gjp9ef5h8u as decodeCollectionSize,
  CompositeDecoder2tzm7wpwkr0og as CompositeDecoder,
  Decoder23nde051s631g as Decoder,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/encoding/Decoding.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { HashMap1a0ld5kgwhmhv as HashMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/HashMap.mjs';
import { Companion_getInstance2o9uk4k3kfl5 as Companion_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/uuid/Uuid.mjs';
import {
  serializer1x80idigipeic as serializer,
  serializer1j5a5justjsv5 as serializer_0,
  serializer37oyvz7rc4nep as serializer_1,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import { Companion_getInstance138pnyl3l6agm as Companion_getInstance_0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/time/Instant.mjs';
import {
  Companion_getInstance3qlladteis94 as Companion_getInstance_1,
  LocalTime22kisvxz6f9p4 as LocalTime,
} from '../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/LocalTime.mjs';
import {
  Companion_getInstance3h03aipe2gus4 as Companion_getInstance_2,
  LocalDate31mqn6zavbpi8 as LocalDate,
} from '../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/LocalDate.mjs';
import {
  Companion_instance3t7kgujds2u7a as Companion_instance,
  YearMonth22nahmknr467s as YearMonth,
} from '../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/YearMonth.mjs';
import {
  Companion_getInstance29buwn7hkq75x as Companion_getInstance_3,
  LocalDateTime3vqv9moe7clf4 as LocalDateTime,
} from '../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/LocalDateTime.mjs';
import {
  Companion_getInstance2jahap30xtp3t as Companion_getInstance_4,
  toDuration7gy6v749ektt as toDuration,
  Duration5ynfiptaqcrg as Duration,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import { DurationUnit_SECONDS_getInstance162tnxlnf2fpv as DurationUnit_SECONDS_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/time/DurationUnitJs.mjs';
import { DurationMsSerializer_getInstancecr673uo7gg5q as DurationMsSerializer_getInstance } from './Serializers.mjs';
import {
  ZonedDateTimeIso8601Serializer_getInstance11y1vnw7kq0m4 as ZonedDateTimeIso8601Serializer_getInstance,
  ZonedDateTime3ek76vws9u4no as ZonedDateTime,
  OffsetDateTimeIso8601Serializer_getInstance1wmrj50dhqyob as OffsetDateTimeIso8601Serializer_getInstance,
  OffsetDateTime32mkjohqthyxu as OffsetDateTime,
} from '../../../../../service-abstractions-data-shared/com/lightningkite/services/data/ZonedDateTime.mjs';
import { Companion_getInstance13ujfby7pfhe7 as Companion_getInstance_5 } from '../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/TimeZone.mjs';
import { Companion_getInstance2fuogtt2v1evi as Companion_getInstance_6 } from '../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/UtcOffset.mjs';
import { TimeZoneSerializer_getInstance3jcki7eba0f0t as TimeZoneSerializer_getInstance } from '../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/serializers/TimeZoneSerializers.mjs';
import {
  GeoCoordinateGeoJsonSerializer_getInstancew33zho1zb4lc as GeoCoordinateGeoJsonSerializer_getInstance,
  GeoCoordinate2xsokvzumk7qu as GeoCoordinate,
  GeoCoordinateArraySerializer_getInstance3ijv0mfbjm6uh as GeoCoordinateArraySerializer_getInstance,
} from '../../../../../service-abstractions-data-shared/com/lightningkite/services/data/GeoCoordinate.mjs';
import {
  EmailAddressSerializer_getInstancezn5b5405tqyz as EmailAddressSerializer_getInstance,
  toEmailAddress1e4w5ykg7qyos as toEmailAddress,
  EmailAddress1cvm8sbtoer9i as EmailAddress,
  PhoneNumberSerializer_getInstanceq35z0l42la4e as PhoneNumberSerializer_getInstance,
  toPhoneNumber2boyry1jrtl94 as toPhoneNumber,
  PhoneNumber16oapr4wkp1a5 as PhoneNumber,
} from '../../../../../service-abstractions-data-shared/com/lightningkite/services/data/StringAlts.mjs';
import { EmptySerializersModule991ju6pz9b79 as EmptySerializersModule } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/modules/SerializersModuleBuilders.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function DefaultDecoder$json$delegate$lambda() {
  return Json(VOID, DefaultDecoder$json$delegate$lambda$lambda);
}
function DefaultDecoder$json$delegate$lambda$lambda($this$Json) {
  $this$Json.serializersModule_1 = DefaultDecoder_getInstance().serializersModule_1;
  $this$Json.encodeDefaults_1 = true;
  return Unit_instance;
}
var DefaultDecoder$beginStructure$1Class;
function DefaultDecoder$beginStructure$1() {
  if (DefaultDecoder$beginStructure$1Class === VOID) {
    class $ {
      constructor() {
        this.index_1 = -1;
      }
      get_serializersModule_piitvg_k$() {
        return DefaultDecoder_getInstance().serializersModule_1;
      }
      decodeBooleanElement_vuyhtj_k$(descriptor, index) {
        return false;
      }
      decodeByteElement_c1pisz_k$(descriptor, index) {
        return 0;
      }
      decodeCharElement_frbao3_k$(descriptor, index) {
        return _Char___init__impl__6a9atx(32);
      }
      decodeDoubleElement_isei84_k$(descriptor, index) {
        return 0.0;
      }
      decodeFloatElement_p2q55h_k$(descriptor, index) {
        return 0.0;
      }
      decodeIntElement_941u6a_k$(descriptor, index) {
        return 0;
      }
      decodeLongElement_994anb_k$(descriptor, index) {
        return 0n;
      }
      decodeShortElement_pzg12t_k$(descriptor, index) {
        return 0;
      }
      decodeStringElement_3oenpg_k$(descriptor, index) {
        var tmp = descriptor.get_kind_wop7ml_k$();
        if (tmp instanceof PolymorphicKind()) {
          var subDesc = descriptor.getElementDescriptor_ncda77_k$(1);
          return subDesc.getElementName_u4sqmf_k$(0);
        }
        return '';
      }
      decodeElementIndex_bstkhp_k$(descriptor) {
        $l$loop: while (true) {
          this.index_1 = this.index_1 + 1 | 0;
          if (this.index_1 >= descriptor.get_elementsCount_288r0x_k$())
            return -1;
          if (!descriptor.isElementOptional_heqq56_k$(this.index_1))
            break $l$loop;
        }
        return this.index_1;
      }
      decodeInlineElement_s8883o_k$(descriptor, index) {
        return DefaultDecoder_getInstance();
      }
      decodeNullableSerializableElement_k2y6ab_k$(descriptor, index, deserializer, previousValue) {
        return null;
      }
      decodeSerializableElement_uahnnv_k$(descriptor, index, deserializer, previousValue) {
        var tmp0_safe_receiver = isInterface(deserializer, KSerializerWithDefault()) ? deserializer : null;
        var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.get_default_qtagd4_k$();
        if (tmp1_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          return tmp1_safe_receiver;
        }
        var tmp2_safe_receiver = DefaultDecoder_getInstance().defaults_1.get_wei43m_k$(deserializer.get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$());
        if (tmp2_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          return tmp2_safe_receiver;
        }
        return deserializer.deserialize_sy6x50_k$(DefaultDecoder_getInstance());
      }
      endStructure_1xqz0n_k$(descriptor) {
      }
    }
    protoOf($).decodeSerializableElement$default_j0zaoi_k$ = decodeSerializableElement$default;
    protoOf($).decodeSequentially_xlblqy_k$ = decodeSequentially;
    protoOf($).decodeCollectionSize_l3mlkk_k$ = decodeCollectionSize;
    initMetadataForClass($, VOID, VOID, VOID, [CompositeDecoder()]);
    DefaultDecoder$beginStructure$1Class = $;
  }
  return DefaultDecoder$beginStructure$1Class;
}
var DefaultDecoderClass;
function DefaultDecoder() {
  if (DefaultDecoderClass === VOID) {
    class $ {
      constructor() {
        DefaultDecoder_instance = this;
        this.defaults_1 = HashMap().new_kotlin_collections_HashMap_2a5kxx_k$();
        var tmp0 = this.defaults_1;
        var tmp2 = serializer(Companion_getInstance()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$();
        // Inline function 'kotlin.collections.set' call
        var value = Companion_getInstance().NIL_1;
        tmp0.put_4fpzoq_k$(tmp2, value);
        var tmp0_0 = this.defaults_1;
        var tmp2_0 = serializer_0(Companion_getInstance_0()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$();
        // Inline function 'kotlin.collections.set' call
        var value_0 = Companion_getInstance_0().fromEpochMilliseconds_uaz65_k$(0n);
        tmp0_0.put_4fpzoq_k$(tmp2_0, value_0);
        var tmp0_1 = this.defaults_1;
        var tmp2_1 = Companion_getInstance_1().serializer_9w0wvi_k$().get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$();
        // Inline function 'kotlin.collections.set' call
        var value_1 = LocalTime().new_kotlinx_datetime_LocalTime_huq53_k$(0, 0, 0);
        tmp0_1.put_4fpzoq_k$(tmp2_1, value_1);
        var tmp0_2 = this.defaults_1;
        var tmp2_2 = Companion_getInstance_2().serializer_9w0wvi_k$().get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$();
        // Inline function 'kotlin.collections.set' call
        var value_2 = LocalDate().new_kotlinx_datetime_LocalDate_81790c_k$(1970, 1, 1);
        tmp0_2.put_4fpzoq_k$(tmp2_2, value_2);
        var tmp0_3 = this.defaults_1;
        var tmp2_3 = Companion_instance.serializer_9w0wvi_k$().get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$();
        // Inline function 'kotlin.collections.set' call
        var value_3 = YearMonth().new_kotlinx_datetime_YearMonth_rc8qre_k$(1970, 1);
        tmp0_3.put_4fpzoq_k$(tmp2_3, value_3);
        var tmp0_4 = this.defaults_1;
        var tmp2_4 = Companion_getInstance_3().serializer_9w0wvi_k$().get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$();
        // Inline function 'kotlin.collections.set' call
        var value_4 = LocalDateTime().new_kotlinx_datetime_LocalDateTime_zaqrue_k$(LocalDate().new_kotlinx_datetime_LocalDate_81790c_k$(1970, 1, 1), LocalTime().new_kotlinx_datetime_LocalTime_huq53_k$(0, 0, 0));
        tmp0_4.put_4fpzoq_k$(tmp2_4, value_4);
        var tmp0_5 = this.defaults_1;
        var tmp2_5 = Companion_instance.serializer_9w0wvi_k$().get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$();
        // Inline function 'kotlin.collections.set' call
        var value_5 = YearMonth().new_kotlinx_datetime_YearMonth_rc8qre_k$(1970, 1);
        tmp0_5.put_4fpzoq_k$(tmp2_5, value_5);
        var tmp0_6 = this.defaults_1;
        var tmp2_6 = serializer_1(Companion_getInstance_4()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$();
        // Inline function 'kotlin.time.Companion.seconds' call
        Companion_getInstance_4();
        var tmp$ret$7 = toDuration(0, DurationUnit_SECONDS_getInstance());
        // Inline function 'kotlin.collections.set' call
        var value_6 = new (Duration())(tmp$ret$7);
        tmp0_6.put_4fpzoq_k$(tmp2_6, value_6);
        var tmp0_7 = this.defaults_1;
        var tmp2_7 = DurationMsSerializer_getInstance().descriptor_1.get_serialName_u2rqhk_k$();
        // Inline function 'kotlin.time.Companion.seconds' call
        Companion_getInstance_4();
        var tmp$ret$9 = toDuration(0, DurationUnit_SECONDS_getInstance());
        // Inline function 'kotlin.collections.set' call
        var value_7 = new (Duration())(tmp$ret$9);
        tmp0_7.put_4fpzoq_k$(tmp2_7, value_7);
        var tmp0_8 = this.defaults_1;
        var tmp2_8 = ZonedDateTimeIso8601Serializer_getInstance().descriptor_1.get_serialName_u2rqhk_k$();
        // Inline function 'kotlin.collections.set' call
        var value_8 = new (ZonedDateTime())(LocalDateTime().new_kotlinx_datetime_LocalDateTime_zaqrue_k$(LocalDate().new_kotlinx_datetime_LocalDate_81790c_k$(1970, 1, 1), LocalTime().new_kotlinx_datetime_LocalTime_huq53_k$(0, 0, 0)), Companion_getInstance_5().UTC_1);
        tmp0_8.put_4fpzoq_k$(tmp2_8, value_8);
        var tmp0_9 = this.defaults_1;
        var tmp2_9 = OffsetDateTimeIso8601Serializer_getInstance().descriptor_1.get_serialName_u2rqhk_k$();
        // Inline function 'kotlin.collections.set' call
        var value_9 = new (OffsetDateTime())(LocalDateTime().new_kotlinx_datetime_LocalDateTime_zaqrue_k$(LocalDate().new_kotlinx_datetime_LocalDate_81790c_k$(1970, 1, 1), LocalTime().new_kotlinx_datetime_LocalTime_huq53_k$(0, 0, 0)), Companion_getInstance_6().ZERO_1);
        tmp0_9.put_4fpzoq_k$(tmp2_9, value_9);
        var tmp0_10 = this.defaults_1;
        var tmp2_10 = TimeZoneSerializer_getInstance().descriptor_1.get_serialName_u2rqhk_k$();
        // Inline function 'kotlin.collections.set' call
        var value_10 = Companion_getInstance_5().currentSystemDefault_9rduv_k$();
        tmp0_10.put_4fpzoq_k$(tmp2_10, value_10);
        var tmp0_11 = this.defaults_1;
        var tmp2_11 = GeoCoordinateGeoJsonSerializer_getInstance().descriptor_1.get_serialName_u2rqhk_k$();
        // Inline function 'kotlin.collections.set' call
        var value_11 = new (GeoCoordinate())(0.0, 0.0);
        tmp0_11.put_4fpzoq_k$(tmp2_11, value_11);
        var tmp0_12 = this.defaults_1;
        var tmp2_12 = GeoCoordinateArraySerializer_getInstance().descriptor_1.get_serialName_u2rqhk_k$();
        // Inline function 'kotlin.collections.set' call
        var value_12 = new (GeoCoordinate())(0.0, 0.0);
        tmp0_12.put_4fpzoq_k$(tmp2_12, value_12);
        var tmp0_13 = this.defaults_1;
        var tmp2_13 = EmailAddressSerializer_getInstance().descriptor_1.get_serialName_u2rqhk_k$();
        // Inline function 'kotlin.collections.set' call
        var value_13 = new (EmailAddress())(toEmailAddress('test@test.com'));
        tmp0_13.put_4fpzoq_k$(tmp2_13, value_13);
        var tmp0_14 = this.defaults_1;
        var tmp2_14 = PhoneNumberSerializer_getInstance().descriptor_1.get_serialName_u2rqhk_k$();
        // Inline function 'kotlin.collections.set' call
        var value_14 = new (PhoneNumber())(toPhoneNumber('+18000000000'));
        tmp0_14.put_4fpzoq_k$(tmp2_14, value_14);
        this.serializersModule_1 = EmptySerializersModule();
        var tmp = this;
        tmp.json$delegate_1 = lazy(DefaultDecoder$json$delegate$lambda);
      }
      get_serializersModule_piitvg_k$() {
        return this.serializersModule_1;
      }
      decodeBoolean_m0aca_k$() {
        return false;
      }
      decodeByte_jzz7je_k$() {
        return 0;
      }
      decodeChar_dcmcfa_k$() {
        return _Char___init__impl__6a9atx(32);
      }
      decodeDouble_ur8l0f_k$() {
        return 0.0;
      }
      decodeFloat_jcnrwu_k$() {
        return 0.0;
      }
      decodeInt_8iq8f5_k$() {
        return 0;
      }
      decodeLong_jzt186_k$() {
        return 0n;
      }
      decodeShort_jjqk32_k$() {
        return 0;
      }
      decodeString_x3hxsx_k$() {
        return '';
      }
      decodeNotNullMark_us4ba1_k$() {
        return true;
      }
      beginStructure_yljocp_k$(descriptor) {
        return new (DefaultDecoder$beginStructure$1())();
      }
      decodeSerializableValue_xpnpad_k$(deserializer) {
        var tmp0_safe_receiver = isInterface(deserializer, KSerializerWithDefault()) ? deserializer : null;
        var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.get_default_qtagd4_k$();
        if (tmp1_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          return tmp1_safe_receiver;
        }
        var tmp2_elvis_lhs = this.defaults_1.get_wei43m_k$(deserializer.get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$());
        return tmp2_elvis_lhs == null ? deserializer.deserialize_sy6x50_k$(this) : tmp2_elvis_lhs;
      }
      decodeEnum_slg6lu_k$(enumDescriptor) {
        return 0;
      }
      decodeInline_ux3vza_k$(descriptor) {
        return this;
      }
      decodeNull_jzrmuj_k$() {
        return null;
      }
    }
    initMetadataForObject($, 'DefaultDecoder', VOID, VOID, [Decoder()]);
    DefaultDecoderClass = $;
  }
  return DefaultDecoderClass;
}
var DefaultDecoder_instance;
function DefaultDecoder_getInstance() {
  if (DefaultDecoder_instance === VOID)
    new (DefaultDecoder())();
  return DefaultDecoder_instance;
}
function default_0(_this__u8e3s4) {
  if (isInterface(_this__u8e3s4, KSerializerWithDefault()))
    return _this__u8e3s4.get_default_qtagd4_k$();
  return DefaultDecoder_getInstance().decodeSerializableValue_xpnpad_k$(_this__u8e3s4);
}
var KSerializerWithDefaultClass;
function KSerializerWithDefault() {
  if (KSerializerWithDefaultClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'KSerializerWithDefault', VOID, VOID, [KSerializer()]);
    KSerializerWithDefaultClass = $;
  }
  return KSerializerWithDefaultClass;
}
//region block: exports
export {
  DefaultDecoder as DefaultDecoder2rhqlc390svhj,
  KSerializerWithDefault as KSerializerWithDefault3c244bl47fg5p,
  default_0 as default1jaun537xukbl,
};
//endregion

//# sourceMappingURL=Defaults.mjs.map
